import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { AirportLocation } from "./AirportLocation/AirportLocation";
import { ChildAirport } from "./ChildAirport/ChildAirport";
import { MapHeader } from "./PageHeading/PageHeading";
import { ParentAirport } from "./ParentAirport/ParentAirport";

export const Maps = () => {
  const query = useQuery();
  const activeTab = query.get("activeTab");
  const navigate = useNavigate();

  useEffect(() => {
    if (!activeTab) {
      navigate(`/dedicated/passenger/maps/?activeTab=mapPageHeading`, {
        replace: true,
      });
    }
  }, [activeTab, navigate]);

  const tabItems = [
    {
      label: "Page Heading",
      key: "mapPageHeading",
      children: <MapHeader />,
    },
    {
      label: "Parent Airport",
      key: "parentAirport",
      children: <ParentAirport />,
    },
    {
      label: "Child Airport",
      key: "childAirport",
      children: <ChildAirport />,
    },
    {
      label: "Airport Locations",
      key: "airportLocations",
      children: <AirportLocation />,
    },
  ];

  const handleActionButton = (tabKey: string) => {
    switch (tabKey) {
      case "parentAirport":
        return (
          <Button
            onClick={() => navigate("/dedicated/passenger/maps/parentAirport/add")}
            icon={<Icon icon="lucide:plus" />}
          >
            Add Parent Airport
          </Button>
        );
      case "childAirport":
        return (
          <Button
            onClick={() => navigate("/dedicated/passenger/maps/childAirport/add")}
            icon={<Icon icon="lucide:plus" />}
          >
            Add Child Airport
          </Button>
        );
      case "airportLocations":
        return (
          <Button
            onClick={() => navigate("/dedicated/passenger/maps/airportLocations/add")}
            icon={<Icon icon="lucide:plus" />}
          >
            Add Airport Locations
          </Button>
        );
      default:
        return null;
    }
  };

  const airportTextMap: Record<string, string> = {
    mapPageHeading: "Airport Specific Content",
    parentAirport: "Global/Non-Airport Specific Content",
    childAirport: "Global/Non-Airport Specific Content",
    airportLocations: "Global/Non-Airport Specific Content",
  };

  const airportText = airportTextMap[activeTab || "mapPageHeading"];

  return (
    <ContentWrapper
      title="Maps"
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleActionButton(activeTab || "airport")}
      airportText={airportText}
    >
      <Tabs
        activeKey={activeTab || "parentAirport"}
        items={tabItems}
        onChange={(key) => navigate(`${window.location.pathname}?activeTab=${key}`)}
      />
    </ContentWrapper>
  );
};
